import { ILead } from 'src/interfaces/lead';
import { IStore, TStoreAreas } from 'src/interfaces/store';
import { isChannelsModeArea } from 'src/modules/conversations/channels';
import { getLeadAreaName } from './getLeadAreaName';

/**
 * Store area the assistant messages the lead from. The store config decides:
 * an area in `channels` mode (OmniChannel) wins over the lead's own area, which
 * only breaks ties between several `channels` areas. Without one, the lead's
 * area (legacy). Null when the store is not populated or has no such area.
 */
export const getLeadStoreArea = (lead: ILead): TStoreAreas | null => {
    const areas = (lead.store as Partial<IStore>)?.areas || [];
    const leadAreaName = getLeadAreaName(lead);
    const isLeadArea = (area: TStoreAreas) => area.name === leadAreaName;
    const channelsAreas = areas.filter(isChannelsModeArea);

    return (
        channelsAreas.find(isLeadArea) ||
        channelsAreas[0] ||
        areas.find(isLeadArea) ||
        null
    );
};

/**
 * Name of the store area the lead is messaged from (see `getLeadStoreArea`).
 */
export const getLeadStoreAreaName = (lead: ILead): string =>
    getLeadStoreArea(lead)?.name || getLeadAreaName(lead);
